export function createTaillightsWorker() {
  return new Worker(new URL('./taillights.worker.ts', import.meta.url), {type: 'module'})
}
